<template>
	<div id="left">
		<div class="cc-header">教师请假</div>
		<dv-scroll-board :config="config" class="leavelist" />
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgId = storage.getItem("orgId");
	export default {
		data() {
			return {
				config: {}
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，1小时
			let _this = this;
			setInterval(() => {
				_this.initData(); // 修改数据date
			}, 1000 * 60 * 60);
		},
		methods: {
			initData() {
				let _this = this;
				this.$http.get("/dataView/headmaster/teacherLeave?orgId=" + orgId).then(res => {
					if (res.data.code === 200) {
						var result = [];
						for (let i = 0; i < res.data.result.length; i+=3) {
							var child = ['<i></i>' + res.data.result[i].teacherName];
							if((i + 1) < res.data.result.length){
								child.push('<i></i>' + res.data.result[i+1].teacherName);
							}
							if((i + 2) < res.data.result.length){
								child.push('<i></i>' + res.data.result[i+2].teacherName);
							}
							result.push(child);
						}
						if(result.length > 0){
							_this.config = {
								data: result,
								headerBGC: '',
								oddRowBGC: 'none',
								evenRowBGC: 'none',
								rowNum: 3,
								waitTime: 2000,
								align: ['left']
							};
						}else{
							_this.config = {
								data: [['<div class="noneData">暂无请假</div>']],
								evenRowBGC: 'none',
								rowNum: 1,
								align: ['center']
							};
						}
					}
				});
			}
		}
	};
</script>

<style lang="scss">
	#left {
		height: 100%;
		.leavelist {
			padding: 0.15rem 2%;
			width: 100%;
			height: 70%;
		}
		
		.leavelist .row-item {
			color: #fff;
			font-size: 0.2rem;
		}

	}
</style>
